import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { ErrorActionsComponent } from '@apps/gc-network/modules/error/actions/error-actions.component';
import {
  ColorModule,
  MipAvatarModule,
  MipIconModule,
  MipProfileSlugNameModule,
  MipTranslateModule,
} from '@lib/gc-common';

@NgModule({
  declarations: [ErrorActionsComponent],
  imports: [
    CommonModule,
    ColorModule,
    MatButtonModule,
    MipAvatarModule,
    MipIconModule,
    MipProfileSlugNameModule,
    MipTranslateModule,
    RouterLink,
  ],
  exports: [ErrorActionsComponent],
})
export class ErrorActionsModule {}
